$(document).ready(function()
{

    var $protectedButtons = $('.protected-downloads-button');
    var $protectedAreas = $('.protected-downloads, .protected-downloads-button, .protected-section');
    var $protectedGates = $('.protected-downloads-gate');
    var $protectedDownloadsModal = $('#protectedDownloadsModal');

    var cookieName = 'downloadsEmail'; // this should match up with PHP DownloadLogger class

    function setCookie(name,value,days) {
        let expires = "";
        if (days && days > 0) {
            let date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function getCookieByName(name) 
    {
        var pair = document.cookie.match(new RegExp(name + '=([^;]+)'));
        return !!pair ? pair[1] : null;
    }

    function stripProtectedButtons()
    {
        $protectedButtons.removeClass('protected-downloads-button');
        $protectedButtons.removeData('bs-toggle');
        $protectedButtons.removeData('bs-target');
        $protectedButtons.removeAttr('data-bs-toggle');
        $protectedButtons.removeAttr('data-bs-target');

    }


    jQuery(document).bind('gform_confirmation_loaded', function(event, formId)
    {

        $protectedAreas.removeClass("active");
        $protectedGates.removeClass("active");
        stripProtectedButtons();
        $protectedDownloadsModal.modal('hide');

		$('html, body').animate({
		    scrollTop: ($protectedAreas.first().offset().top) - 200
		},500);

    });

    // on submit set a cookie for tracking purposes
    $('#protectedDownloadsModal form').submit(function( e )
    {
        var cluster = $(this).find(".user_email");

        if (cluster.length)
        {
            cluster.each(function()
            {
                var email = $(this).find("input").val();
                if (email && email.length)
                {
                    setCookie(cookieName, email, 0);
                }
            });
        }
    });

    $protectedButtons.on('click', function(e)
    {
        // handled by BS modal
    });

    //console.log(getCookieByName(cookieName));

    // on load, if session cookie is set, we don't need any ot this
    if (getCookieByName(cookieName))
    {
        $protectedAreas.removeClass("active");
        $protectedGates.removeClass("active");
        $protectedDownloadsModal.modal('hide');
        stripProtectedButtons();
    }

});